import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setDecompositionTreeMinMaxTasks as setDecompositionTreeMinMaxTasksDiagram, getDecompositionTreeMinMaxTasks as getDecompositionTreeMinMaxTasksDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setDecompositionTreeMinMaxTasks = ({
    min,
    max,
}: MinMaxProps) => {
    setDecompositionTreeMinMaxTasksDiagram({min, max});
};


export const getDecompositionTreeMinMaxTasks = (): MinMaxProps => getDecompositionTreeMinMaxTasksDiagram();
